import { NavLink } from "react-router-dom";

import { useSelector } from "react-redux";

import {
  HiOutlineHome,
  HiOutlineUsers,
  HiOutlineUserGroup,
  HiOutlineClipboardDocumentList,
  HiOutlineCog6Tooth,
  HiOutlineXMark,
  HiOutlineCalendarDays,
  HiOutlineRectangleGroup,
  HiOutlineBuildingOffice2,
} from "react-icons/hi2";
import { FaUsers } from "react-icons/fa";

import usePermissions from "../../../hooks/usePermissions";

import "./Sidebar.css";
import { FiUserCheck } from "react-icons/fi";
import { RiFilePaperLine } from "react-icons/ri";

/**
 * NAVIGATION
 */
const navigation = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: HiOutlineHome,
    permission: null,
  },

  /**
   * USERS
   */
  {
    label: "Gebruikers",
    path: "/dashboard/users",
    icon: HiOutlineUsers,
    permission: "users.read",
    roles: ["POWER_ADMIN"],
  },

  /**
   * DOSSIERS / JONGEREN
   */
  {
    label: "Jongeren",
    path: "/dashboard/jongeren",
    icon: HiOutlineUserGroup,
    permission: "jongeren.read",
    roles: ["POWER_ADMIN"],
  },

  /**
   * REGISTRATIONS
   */
  {
    label: "Registraties",
    path: "/dashboard/registraties",
    icon: HiOutlineClipboardDocumentList,
    permission: "registrations.read",
  },

  /**
   * SCHOOL YEARS
   */
  {
    label: "Schooljaren",
    path: "/dashboard/school-years",
    icon: HiOutlineCalendarDays,
    permission: "schoolYear.read",
    roles: ["POWER_ADMIN"],
  },

  /**
   * FIELD CONFIGS
   */
  {
    label: "Velden",
    path: "/dashboard/field-configs",
    icon: HiOutlineRectangleGroup,
    permission: "fieldConfig.read",
    roles: ["POWER_ADMIN"],
  },
  {
    label: "Coaches",
    path: "/dashboard/users",
    icon: FiUserCheck,
    permission: "user.read",
    roles: ["POWER_ADMIN"],
  },
  {
    label: "Jongeren",
    path: "/dashboard/clients",
    icon: FaUsers,
    permission: "client.read",
    roles: ["POWER_ADMIN"],
  },
  {
    label: "Trajecten",
    path: "/dashboard/dossiers",
    icon: RiFilePaperLine,
    permission: "dossier.read",
  },
  /**
   * ORGANIZATIONS
   */
  {
    label: "Organisaties",
    path: "/dashboard/organizations",
    icon: HiOutlineBuildingOffice2,
    permission: "organization.admin",
    roles: ["POWER_ADMIN"],
  },
  /**
   * SETTINGS
   */
  {
    label: "Instellingen",
    path: "/dashboard/settings",
    icon: HiOutlineCog6Tooth,
  },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user } = useSelector((state) => state.auth);

  const { can } = usePermissions();

  /**
   * FILTER NAVIGATION
   */
  const visibleNavigation = navigation.filter(
    (item) =>
      can(item.permission) && (!item.roles || item.roles.includes(user?.role)),
  );

  return (
    <aside className={`sidebar ${isOpen ? "sidebar--open" : ""}`}>
      {/* HEADER */}
      <div className="sidebar__header">
        <div>
          <span className="sidebar__eyebrow">TOPunt Gent</span>

          <img src="/Power.png" alt="POWER Logo" className="sidebar__logo" />
        </div>

        <button className="sidebar__close" onClick={onClose}>
          <HiOutlineXMark />
        </button>
      </div>

      {/* USER */}
      <div className="sidebar__user">
        <div className="sidebar__avatar">
          {user?.first_name?.charAt(0) || "U"}
        </div>

        <div className="sidebar__user-info">
          <span>
            {user?.first_name} {user?.last_name}
          </span>

          <small>
            {{
              POWER_ADMIN: "Beheerder",
              POWER_INTERNAL_COACH: "Interne Coach",
              POWER_EXTERNAL_COACH: "Externe Coach",
            }[user?.role] || user?.role}
          </small>
        </div>
      </div>

      {/* NAVIGATION */}
      <nav className="sidebar__nav">
        {visibleNavigation.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/dashboard"}
              className={({ isActive }) =>
                `sidebar__link ${isActive ? "sidebar__link--active" : ""}`
              }
            >
              <Icon />

              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
